import React from "react";
// import RequiredFieldIcon from "../common/RequiredFieldIcon";

const ProjectName = ({
  projectName,
  setProjectName,
  show,
  setShow,
}: {
  projectName: string;
  setProjectName: (newState: string) => void;
  show: boolean;
  setShow: (key: string) => void;
}) => {
  return (
    <div className="component">
      {/* <RequiredFieldIcon /> */}
      <div onClick={() => setShow("projectName")} className="title">
        <p>
            Project Name&nbsp;
            {projectName.length > 0 && (
              <span className="ml_3" style={{ color: "#007bff", fontWeight: 500 }}>
                ({projectName.length > 30 ? projectName.substring(0, 27) + '...' : projectName})
              </span>
            )}
        </p>
        <i className={`${show && "rotate"} fa-solid fa-chevron-down`}></i>
      </div>
      {show && (
        <div className="search_input_container without_border_component">
          <input
            type="text"
            className="search_input"
            value={projectName}
            onChange={(event) => {
              setProjectName(event.target.value);
            }}
            placeholder="Enter project name..."
            autoFocus
          />
        </div>
      )}
    </div>
  );
};
export default ProjectName;
